import { Select, InputLabel, FormControl, FormHelperText, MenuItem, menuItemClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import AvatarIcon from "../../assets/icons/Avatar.js";
import "react/jsx-runtime";
const EmployeesDropdown = styled(Select, { shouldForwardProp: (prop) => prop !== "$isValid" })(
  ({ disabled, $isValid }) => ({
    "&:hover::before,&:hover::after,&::before,&::after": {
      border: "none"
    },
    "& .MuiInput-root": {
      border: "none"
    },
    ".MuiInputBase-input:focus": {
      background: "transparent"
    },
    border: "1px solid #00A08D",
    borderRadius: "32px",
    background: "#EDF8F7",
    marginTop: "12px",
    padding: "4px 0px",
    minHeight: "56px",
    "&:hover": {
      boxShadow: "0 0 0 0.5px #008F79"
    },
    ...disabled && {
      borderColor: "#757575",
      background: "#F5F5F5"
    },
    ...!$isValid && {
      borderColor: "#DD3C49",
      background: "#fef1f3"
    }
  })
);
const EmployeesFieldLabel = styled(InputLabel)(() => ({
  transform: "translate(16px, -4px) scale(0.75)",
  fontWeight: 700,
  maxWidth: "770px",
  color: "#00725E"
}));
const TaskFormControl = styled(FormControl)(() => ({
  marginTop: "10px"
}));
const ErrorMessage = styled(FormHelperText)(() => ({
  color: "#B5223B",
  fontWeight: 400,
  marginLeft: 0,
  fontSize: "0.75rem"
}));
const AvatarContainer = styled("div")(() => ({
  background: "#E0E0E0",
  border: "2px solid #FAFAFA",
  width: "32px",
  height: "32px",
  borderRadius: "32px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));
const Avatar = styled(AvatarIcon)(() => ({
  width: 18
}));
const Placeholder = styled("span")(() => ({
  paddingLeft: "6px",
  fontSize: "15px"
}));
const StyledMenuItem = styled(MenuItem)(() => ({
  [`&.${menuItemClasses.root}`]: {
    paddingTop: 12,
    paddingBottom: 12,
    color: "#004734",
    backgroundColor: "#fff",
    [`&:hover:not(.${menuItemClasses.selected}, .${menuItemClasses.focusVisible})`]: {
      backgroundColor: "#caede7",
      [`span`]: {
        color: "#004734"
      }
    },
    [`&.${menuItemClasses.selected}, &.${menuItemClasses.focusVisible}, &.${menuItemClasses.selected}.${menuItemClasses.focusVisible}`]: {
      backgroundColor: "#00624F",
      color: "#fff",
      [`span, p`]: {
        color: "#fff"
      }
    },
    [`&.${menuItemClasses.selected}:hover, &.${menuItemClasses.selected}.${menuItemClasses.focusVisible}:hover, &.${menuItemClasses.focusVisible}:hover`]: {
      backgroundColor: "#004734"
    }
  }
}));
export {
  Avatar,
  AvatarContainer,
  EmployeesDropdown,
  EmployeesFieldLabel,
  ErrorMessage,
  Placeholder,
  StyledMenuItem,
  TaskFormControl
};
